module.exports = __webpack_public_path__ + "0ebcf8bba7d55e4158645d7a54b32b0e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/exercise-small.png
// module id = 186
// module chunks = 0